import React from 'react';   
import axios from 'axios';
import * as utils from '../../utils';
import * as apis from '../../constants/Apis';
import Layout from '../../components/Layout';
import Portlet from '../../components/Portlet';
import image from '../../assets/rta.png';
import DataTable from '../../components/DataTable';
import {ToastContainer} from 'react-toastr';
import '../../assets/css/toastr.css';

class DetailPayment extends React.Component{
    constructor(props){
        super(props);
        let params = new URLSearchParams(props.location.search);
        this.state ={
            invoiceID : params.get('Iv'),
            data : [],
            meta : {
                currentPage: 1,
                perPage: 10
            }
        }
    }

    changeMeta(meta){
        this.setState({meta})
    }

    componentDidMount(){
        let _this = this;
        const {t} = this.props
        this.setState({showLoading: true})
        let config = utils.getConfig();
        axios.get(apis.BASE_URL + 'users/invoice/'+ _this.state.invoiceID, config)
        .then( res => {
            _this.setState({
                data: res.data.items
            });
        })
        .catch( error => {
            if(error.response){
               _this.refs.toastContainer.error(utils.catchMessageError(error.response.data.error_code))
            }
            else{
                this.refs.toastContainer.error(t('Sorry! Error Server'))
            }
        });
    }

    render(){ 
        const { t } = this.props
        const {data, meta} = this.state;
        let config = {
            api: false,
            cols: [
                { property: "description", header: t("DESCRIPTION"), sortable: true,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => value
                },
                { property: "startDate", header: t("START DATE"), sortable: true,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => value
                },             
                { property: "amount", header: t("AMOUNT"), sortable: true,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value =>'$'+value+' (USD)'
                },
                { property: "description", header: t("COMMENTS"), sortable: true,
                    decorator : () => ({ style : { width : "20%" } }),
                    renderer : value => null
                },               
            ]
        }

        return(
            <Layout>
                <Layout.Content>
                    <Portlet>
                        <Portlet.Body>
                            <div className="m-invoice-2">
                                <div className="m-invoice__wrapper">
                                    <div className="m-invoice__head">
                                        <div className="m-invoice__container m-invoice__container--centered">
                                            <div className="m-invoice__logo">
                                                <a href="/">
                                                    <h1>{t('Invoice')} {data.invoiceNumber}</h1>
                                                </a>
                                                <a href="/">
                                                    <img src={image} alt="" style={{width:"40%"}}/>
                                                </a>
                                            </div>
                                            <span className="m-invoice__desc">
                                                <span>{t('45 Vo Thi Sau Da Kao')}</span>
                                            </span>
                                            <div className="m-invoice__items">
                                            <div className="row">
                                                <div className="col-lg-5 col-12 invoice_content">
                                                    <div className="invoice_text">
                                                        <span className= "info">{t('INVOICE DATE')}</span>
                                                        <span className= "amount">{data.invoiceDate}</span>
                                                    </div>
                                                    <div className="invoice_text">
                                                        <span className= "info">{t('TARGET DATE')}</span>
                                                        <span className= "amount">{data.targetDate}</span>
                                                    </div></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {data.items ? <DataTable t={t} datasource={data.items} config={config} meta={meta} changeMeta={this.changeMeta.bind(this)}/> : null}
                                       
                                    <div className="row f-invoice">
                                        <div className="col-lg-5 col-12"></div>
                                        <div className="col-lg-6 col-12 footer_invoice">
                                            <div className="invoice_text">
                                                <span className= "info">{t('INVOICE TOTAL')}:</span>
                                                <span className= "amount">$0 (USD)</span>
                                            </div >
                                            <div className="invoice_text">
                                                <span className= "info">{t('CREDITS')}:</span>
                                                <span className= "amount">${data.creditAdj} (USD)</span>
                                            </div>
                                            <div className="invoice_text">
                                                <span className= "info">{t('REFUNDED')}:</span>
                                                <span className= "amount">${data.refundAdj} (USD)</span>
                                            </div>
                                            <div className="invoice_text">
                                                <span className= "info">{t('BALANCE')}:</span>
                                                <span className= "amount">${data.balance} (USD)</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-1 col-12"></div>
                                    </div>
                                </div>
                            </div>
                        </Portlet.Body>
                    </Portlet>
                </Layout.Content>
                <ToastContainer ref="toastContainer" className="toast-top-right"/>                                  
            </Layout>
        );
    }
}

export default DetailPayment;
